import { IFolder, EReportsListV4ItemType, IReportV4 } from '@opengov/reporting-types';
import { Folder, Item } from '@opengov/bnp-component-folders/src';

export const ACTION_ERROR_CODES = {
  FOLDERS_NESTING_EXCEEDS_7_LEVELS: 'FOLDERS_NESTING_EXCEEDS_7_LEVELS',
  NOT_FOUND_OR_PERMISSION_DENIED: 'NOT_FOUND_OR_PERMISSION_DENIED',
  INTERNAL_ERROR: 'INTERNAL_ERROR'
} as const;

export type FoldersAndReportsActionPayload = {
  sourceFolderIds: string[];
  sourceReportIds: string[];
  destinationFolderId: string;
};

export type ItemsActionResponse = {
  moved: {
    folders: ActionItem[];
    reports: ActionItem[];
    total: number;
  };
  failed: {
    folders: ActionError[];
    reports: ActionError[];
    total: number;
  };
};

export type ActionItem = {
  id: number | string;
  title: string;
};

export type ActionError = {
  id: number | string;
  reason: {
    code: string;
    message: string;
  };
};

type ExtendedActionError = Item & {
  code: ActionError['reason']['code'];
  type: EReportsListV4ItemType;
};

export const getRetryIds = (items: ExtendedActionError[]) => {
  return items.reduce<string[]>((acc, item) => {
    if (
      item.code !== ACTION_ERROR_CODES.NOT_FOUND_OR_PERMISSION_DENIED &&
      item.code !== ACTION_ERROR_CODES.FOLDERS_NESTING_EXCEEDS_7_LEVELS
    ) {
      acc.push(`${item.id}`);
    }
    return acc;
  }, []);
};

export const getExtendedActionErrors = (
  actionErrors: ActionError[],
  parentFolderId: Folder['id'],
  items: (IFolder | IReportV4)[]
) => {
  return actionErrors.reduce<ExtendedActionError[]>((acc, actionError) => {
    const item = items.find((item) => `${item.id}` === `${actionError.id}`);
    if (item) {
      acc.push({
        id: `${actionError.id}`,
        title: item.title,
        type: item.type,
        parentFolderId,
        code: actionError.reason.code
      });
    }
    return acc;
  }, []);
};
